import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.CONTENT_BY_UUID](state) {
        return (uuid) => state[uuid];
    },
};
